/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_OkInputs */

const en_tut_kantor_ok = /** @type {(inputs: Tut_Kantor_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dot in the header turns into **Hadir di kantor** and your avatar is visible to anyone with the same page open.`)
};

const id_tut_kantor_ok = /** @type {(inputs: Tut_Kantor_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik hijau di header berubah menjadi **Hadir di kantor** dan avatar Anda terlihat oleh rekan yang sedang membuka halaman yang sama.`)
};

/**
* | output |
* | --- |
* | "The dot in the header turns into **Hadir di kantor** and your avatar is visible to anyone with the same page open." |
*
* @param {Tut_Kantor_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_ok = /** @type {((inputs?: Tut_Kantor_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_ok(inputs)
	return en_tut_kantor_ok(inputs)
});